export const PHONE_NUMBER = "+919700455372";
export const PHONE_DISPLAY = "+91 97004 55372";
export const WHATSAPP_NUMBER = "919700455372";

export const CLINIC_NAME = "Smart Dental Clinic";
export const TAGLINE = "Complete Dental Care for You & Your Family";

export const ADDRESS_LINES = [
  "Shop No. 19-1-878/4/F/G,",
  "Sri Devi Bagh Temple,",
  "Bahadurpura Police Station Road,",
  "Opp. Flyover Ramp,",
  "Hyderabad – 500064, Telangana, India.",
];

export const MAP_QUERY =
  "Smart Dental clinic, near Police Station, Devi Bagh, Bahadurpura, Hyderabad, Telangana 500064";
export const MAP_EMBED_URL = `https://www.google.com/maps?q=${encodeURIComponent(
  MAP_QUERY
)}&output=embed`;
export const MAPS_DIR_URL = "https://maps.app.goo.gl/fMie9w9YEnd2fcAZA";

const uns = (id, w = 900) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=65`;
const pex = (id, w = 900) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const HERO_IMAGE = uns("1606811841689-23dfddce3e95", 1600);
export const ABOUT_IMAGE = pex(3845810, 1200);
export const ABOUT_IMAGE_2 = uns("1629909615184-74f495363b67", 700);
export const VISITING_BG = pex(9062527, 1400);
export const CONTACT_IMAGE = pex(6809652, 1200);

export const TIMINGS = [
  { day: "Monday – Thursday", hours: ["11:00 AM – 3:00 PM", "4:30 PM – 9:00 PM"] },
  { day: "Friday", hours: ["3:00 PM – 9:00 PM"] },
  { day: "Saturday", hours: ["11:00 AM – 3:00 PM", "4:30 PM – 9:00 PM"] },
  { day: "Sunday", hours: [], closed: true },
];

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "dentists", label: "Dentists" },
  { id: "treatments", label: "Treatments" },
  { id: "gallery", label: "Gallery" },
  { id: "contact", label: "Contact" },
];

export const DOCTORS = [
  {
    name: "Dr. Shaik Nayeem Ahmed",
    role: "Managing Director",
    detail: "Smart Dental Clinic",
    initials: "NA",
    photo: "/doctors/nayeem.webp",
  },
  {
    name: "Dr. D.V.D. Yaseswini",
    role: "Consultant Doctor · Dental Surgeon",
    detail: "B.D.S, FRCD, MOI",
    initials: "DY",
    photo: "/doctors/yaseswini.webp",
  },
  {
    name: "Dr. Jaweed Jabbar",
    role: "Consultant Doctor",
    detail: "Smart Dental Clinic",
    initials: "JJ",
    photo: "/doctors/jabbar.webp",
  },
];

const wmc = (file, w = 800) =>
  `https://commons.wikimedia.org/wiki/Special:FilePath/${file}?width=${w}`;

export const TREATMENTS = [
  {
    icon: "rct",
    name: "Root Canal Treatment (RCT)",
    desc: "Gentle care to relieve deep tooth pain and help save your natural tooth.",
    img: "/treatments/rct.webp",
    alt: "Root canal treatment being performed (clinic-approved image)",
  },
  {
    icon: "extraction",
    name: "Tooth Extraction",
    desc: "Safe, comfortable removal of damaged or problematic teeth.",
    img: "/treatments/extraction.webp",
    alt: "Tooth extraction being performed (clinic-approved image)",
  },
  {
    icon: "cleaning",
    name: "Teeth Cleaning & Scaling",
    desc: "A thorough clean that clears plaque and tartar for healthier gums.",
    img: "/treatments/cleaning.webp",
    alt: "Teeth cleaning and scaling being performed (clinic-approved image)",
  },
  {
    icon: "filling",
    name: "Dental Fillings",
    desc: "Tooth-coloured fillings that repair cavities and restore your smile.",
    img: "/treatments/filling.webp",
    alt: "Composite dental filling being cured (clinic-approved image)",
  },
  {
    icon: "crown",
    name: "Dental Crowns",
    desc: "Strong, natural-looking caps that protect and rebuild weakened teeth.",
    img: "/treatments/crowns.webp",
    alt: "Dental crown being placed (clinic-approved image)",
  },
  {
    icon: "bridge",
    name: "Fixed Dental Bridges (FPD)",
    desc: "Fixed replacements that neatly fill the gaps left by missing teeth.",
    img: "/treatments/bridge.webp",
    alt: "Fixed dental bridge placement (clinic-approved image)",
  },
  {
    icon: "denture",
    name: "Complete & Partial Dentures",
    desc: "Comfortable, well-fitting dentures that bring back easy eating and smiling.",
    img: "/treatments/denture.webp",
    alt: "Complete and partial dentures (clinic-approved image)",
  },
  {
    icon: "braces",
    name: "Orthodontic Treatment (Braces)",
    desc: "Braces that gently guide teeth into a straighter, healthier alignment.",
    img: "/treatments/braces.webp",
    alt: "Orthodontic braces treatment (clinic-approved image)",
  },
  {
    icon: "gum",
    name: "Gum Treatment",
    desc: "Gentle care for swollen, bleeding or infected gums to keep your smile healthy.",
    img: "/treatments/gum.webp",
    alt: "Gum treatment for healthy gums (clinic-approved image)",
  },
  {
    icon: "kids",
    name: "Kids Dental Care",
    desc: "Friendly, patient check-ups and treatments that keep little smiles healthy.",
    img: "/treatments/kids.webp",
    alt: "Dentist gently treating a child (clinic-approved image)",
  },
  {
    icon: "implant",
    name: "Dental Implants",
    desc: "A stable, long-lasting replacement option for missing teeth.",
    img: "/treatments/implant.webp",
    alt: "Dental implant with crown, abutment and titanium screw (clinic-approved image)",
  },
];
